/**
 * Id generation for `core`.
 *
 * `core` must not touch browser globals, so it cannot call `crypto.randomUUID()`.
 * Instead it defines the contract and ships a dependency-free default: a counter
 * seeded by the caller. Ids are stable strings, which is what the (deferred) sync
 * layer will need; uniqueness across devices is the caller's problem to solve by
 * choosing a distinct seed.
 */

export type Id = string;

export type IdFactory = (prefix: string) => Id;

/**
 * Creates a monotonic id factory. `seed` should be unique per document session
 * (the web app passes a random base36 string derived from `crypto`).
 */
export function createIdFactory(seed: string): IdFactory {
  let counter = 0;
  return (prefix: string): Id => {
    counter += 1;
    return `${prefix}_${seed}${counter.toString(36)}`;
  };
}
